/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterDetailModelSearchResultModel } from '../../models/encounter-detail-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface EncounterFacilityIdEncountersPractitionerIdPost$Params {
  facilityId: string;
  practitionerId: string;
      body?: SearchRequestModel
}

export function encounterFacilityIdEncountersPractitionerIdPost(http: HttpClient, rootUrl: string, params: EncounterFacilityIdEncountersPractitionerIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<EncounterDetailModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, encounterFacilityIdEncountersPractitionerIdPost.PATH, 'post');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.path('practitionerId', params.practitionerId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<EncounterDetailModelSearchResultModel>;
    })
  );
}

encounterFacilityIdEncountersPractitionerIdPost.PATH = '/Encounter/{facilityId}/Encounters/{practitionerId}';
